import { render, staticRenderFns } from "./ColorPickerModal.vue?vue&type=template&id=70adf7b9"
import script from "./ColorPickerModal.vue?vue&type=script&lang=js"
export * from "./ColorPickerModal.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerModal.vue?vue&type=style&index=0&id=70adf7b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports